import { Injectable } from '@angular/core';
import {
  MediaObserver,
  MediaChange
} from '@angular/flex-layout';
import {
  mergeMap,
  map,
  filter,
  distinctUntilChanged,
  tap
} from 'rxjs/operators';
import { Effect } from '@ngrx/effects';
import {
  XSLayout,
  SMLayout,
  MDLayout,
  LGLayout,
  XLLayout,
  GTSMLayout,
  GTMDLayout,
  GTXSLayout,
  LTXLLayout,
  LTLGLayout,
  LTSMLayout,
  LTMDLayout,
  GTLGLayout,
  ScreenActions
} from '../actions/screen.actions';
import { LifeCycleService } from '../../life-cycle/life-cycle.service';

@Injectable()
export class ScreenEffects {

  @Effect()
  public mediaObserver$ = this.lifecycle.whenReady(this.mediaObserver.asObservable().pipe(
    map(queries => queries.sort((a, b) => a.priority - b.priority)),
    mergeMap(queries => queries),
    map(this.queryToAction),
    filter(Boolean),
  ));

  public queryToAction(query: MediaChange): ScreenActions | null {
    switch (query.mqAlias) {

      case 'xs':
        return new XSLayout();

      case 'md':
        return new MDLayout();

      case 'sm':
        return new SMLayout();

      case 'lg':
        return new LGLayout();

      case 'xl':
        return new XLLayout();

      case 'lt-md':
        return new LTMDLayout();

      case 'lt-sm':
        return new LTSMLayout();

      case 'lt-lg':
        return new LTLGLayout();

      case 'lt-xl':
        return new LTXLLayout();

      case 'gt-xs':
        return new GTXSLayout();

      case 'gt-md':
        return new GTMDLayout();

      case 'gt-sm':
        return new GTSMLayout();

      case 'gt-lg':
        return new GTLGLayout();

      default:
        return null;

    }
  }

  public constructor(
    private mediaObserver: MediaObserver,
    private lifecycle: LifeCycleService,
  ) {}

}
